<div id="snapshotPdf" class="flex flex-col gap-2 f-s-12" style="max-width: 1000px; width: 100%; font-size: 12px; line-height: 1.5; word-wrap: break-word; overflow-wrap: break-word; word-break: break-word; zoom: reset; -webkit-text-size-adjust: 100%; -moz-text-size-adjust: 100%; text-size-adjust: 100%;">
  <mat-card>
    <mat-card-title>
      <div><span class="strong">License type: </span>&nbsp;&nbsp;&nbsp;&nbsp;Manufacturer</div>
      <div><span class="strong">License ID: </span>&nbsp;&nbsp;&nbsp;&nbsp;{{license.licenseId}}</div>
      <div><span class="strong">Date of application submission: </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{license.applicationDate}}</div>
      <div><span class="strong">Renewal number: </span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{parentComponent.getRenewalNumber(license)}}</div>
      <div><span class="strong">Approved Date:</span>&nbsp;&nbsp;&nbsp;&nbsp;{{license.approvedDate | date:'MM/dd/yyyy'}}</div>
      <div><span class="strong">Expiration Date:</span>&nbsp;&nbsp;&nbsp;&nbsp;{{license.expirationDate | date:'MM/dd/yyyy'}}</div>
    </mat-card-title>
    <div class="flex flex-col gap-4">
      <mat-card-title>Approved Endorsements and ODA Licensure</mat-card-title>
      <span>
        <span class="k-icon"  [ngClass]="license.fungiCultivationApproved ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
        <span class="text-wrap">Fungi Cultivation</span>
      </span>
      <span *ngIf="license.fungiCultivationApproved">Date of OPS License Approval: {{license.fungiCultivationApprovedDate | date:'MM/dd/yyyy'}}</span>

      <span>
        <span class="k-icon"  [ngClass]="license.fungiCultivationODALicensureApproved ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
        <span class="text-wrap">Fungi Cultivation that Requires ODA Licensure</span>
      </span>
      <span *ngIf="license.fungiCultivationODALicensureApproved">Date of ODA License Approval: {{license.fungiCultivationODALicensureApprovedDate | date:'MM/dd/yyyy'}}</span>
      <span *ngIf="license.fungiCultivationODALicensureApproved">Date of ODA License Expiration: {{license.fungiCultivationODALicensureExpiredDate | date:'MM/dd/yyyy'}}</span>

      <span>
        <span class="k-icon"  [ngClass]="license.psilocybinExtractionApproved ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
        <span class="text-wrap">Psilocybin Extraction</span>
      </span>
      <span *ngIf="license.psilocybinExtractionApproved">Date of ODA License Approval: {{license.psilocybinExtractionApprovedDate | date:'MM/dd/yyyy'}}</span>
      <span *ngIf="license.psilocybinExtractionApproved">Date of ODA License Expiration: {{license.psilocybinExtractionExpiredDate | date:'MM/dd/yyyy'}}</span>

      <span>
        <span class="k-icon"  [ngClass]="license.ediblePsilocybinProductionApproved ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
        <span class="text-wrap">Edible Psilocybin Production</span>
      </span>
      <span *ngIf="license.ediblePsilocybinProductionApproved">Date of ODA License Approval: {{license.ediblePsilocybinProductionApprovedDate | date:'MM/dd/yyyy'}}</span>
      <span *ngIf="license.ediblePsilocybinProductionApproved">Date of ODA License Expiration: {{license.ediblePsilocybinProductionExpiredDate | date:'MM/dd/yyyy'}}</span>
    </div>
    <mat-card-title>Documents</mat-card-title>
    <div *ngIf="!sharedService.mobile" class="flex flex-row">
      <span class="f-s-16 w-[35%]"><strong>File</strong></span>
      <span class="f-s-16 w-[25%]"><strong>Requirement</strong></span>
      <span class="f-s-16 w-[20%]"><strong>Date Uploaded</strong></span>
    </div>
    <div *ngFor="let document of this.license.licenseDocuments" class="max-md:flex-col flex flex-row justify-start items-center">
      <ng-container *ngIf="!document.deprecated && (document.types.includes(fungiCultivationType) || document.types.includes(psilocybinExtractionType) || document.types.includes(ediblePsilocybinProductionType))">
        <span class="text-indigo-A700 w-[35%]" style="cursor: pointer; overflow: hidden; text-overflow: ellipsis;" [matTooltip]="document.name" matTooltipShowDelay="500">{{document.name}}</span>

        <span *ngFor="let type of document.types" class="w-[25%]">
          <span *ngFor="let docType of documentTypes">
            <span *ngIf="docType.id == type"> {{docType.type}} </span>
          </span>
        </span>

        <span class="w-[20%]">{{document.dateCreated | date}}</span>
      </ng-container>
    </div>
  </mat-card>

  <mat-card >
    <mat-card-title>
      Getting Started Page
    </mat-card-title>

    <mat-card-content>
      <div style="padding-top: 1em" class="flex flex-col gap-2">
        <span>
          <span *ngIf="!license.isRenewal">Thank you for your interest in applying for a psilocybin manufacturer license through the Oregon Psilocybin Services - Training Program, Licensing, and Compliance system (TLC).</span>
          <span *ngIf="license.isRenewal">Thank you for your interest in applying to renew your psilocybin manufacturer license through the Oregon Psilocybin Services - Training Program, Licensing, and Compliance system (TLC). </span>
        </span>
        <span class="strong">
          <span *ngIf="!license.isRenewal">
            <u>One applicant must be designated as the Primary Point of Contact for communication.
                The primary point of contact is responsible for ensuring all persons identified as licensees or
                applicants are aware of relevant communications, including but not limited to notices issued under ORS Chapter 183.
            </u>
          </span>
          <span *ngIf="license.isRenewal"><u>One applicant must be designated as the Primary Point of Contact for communication. The primary point of contact is responsible for ensuring
            all persons identified as licensees or applicants are aware of relevant communications, including but not limited to notices issued under ORS Chapter
            183. If the primary point of contact will be different upon renewal, please send this through the change request process. Change request process documents
            can be found on the TLC Home Page.</u></span>
        </span>
      </div>
      <div style="padding-top: 1em" class="flex flex-col gap-2">
        <span class="strong"><u>Applicants must read, understand, and agree to adhere to the Oregon Psilocybin Services Revised Statutes
          (ORS) Chapter 475A,
          Oregon Administrative Rules (OAR) Chapter 333, Division 333, as well as
          any other applicable statutes or laws.</u></span>
      </div>
      <div style="padding-top: 1em" class="flex flex-col gap-2">
        <strong *ngIf="!license.isRenewal">The completed application packet contains the following:</strong>
        <strong *ngIf="license.isRenewal">A completed renewal application packet contains the following: </strong>

        <ul>
          <li *ngIf="!license.isRenewal">Completed and signed manufacturer license application
          </li>
          <li *ngIf="license.isRenewal">Completed and signed manufacturer license renewal application
          </li>
          <li *ngIf="!license.isRenewal">Uploaded copy of the front and back of a valid, unexpired government-issued photo identification for the applicant(s)
          </li>
          <li *ngIf="!license.isRenewal">Uploaded copy of the approved Land Use Compatibility Statement (LUCS)
          </li>
          <li>Uploaded individual and entity applicant information forms for each applicant
          </li>
          <li *ngIf="!license.isRenewal">Uploaded premises plan
          </li>
          <li *ngIf="!license.isRenewal">Uploaded copy of the social equity plan
          </li>
          <li *ngIf="!license.isRenewal">Uploaded copy of the property owner statement (if applicable)
          </li>
          <li *ngIf="!license.isRenewal"><strong>$500</strong>&nbsp;&nbsp;&nbsp;Non-refundable manufacturer license application fee paid and cleared
          </li>
          <li *ngIf="license.isRenewal">Uploaded evaluation of last year's Social Equity Plan
          </li>
          <li style="display: block; word-wrap: break-word; overflow-wrap: break-word;">Uploaded copy of the &nbsp;&nbsp;&nbsp;<span class="strong">front and back</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;of a valid, unexpired government-issued photo identification
            </li>
        </ul>
      </div>
      <div style="padding-top: 1em" class="flex flex-col gap-2">
        <strong>Important Notes:</strong>
        <ul>
        <li>Please review each section of the application to ensure it is complete
        </li>
        <li *ngIf="!license.isRenewal">Toward the end of the application, fee page will describe how to submit the application fee which may be paid online or in-person
        </li>
        <li *ngIf="license.isRenewal">Toward the end of the renewal application, a fee page will describe how to submit the renewal license fee which may be paid online, by mail or in-person
        </li>
        <li *ngIf="!license.isRenewal">OPS will not review an application packet until the application fee is paid and cleared. You have 90 days from the date of application submission to pay the application fee or it will be closed.
        </li>
        <li *ngIf="!license.isRenewal">
          <strong>Incomplete and Insufficient Application Statuses:</strong>
        </li>
        </ul>
        <div style="padding-left: 1em;" *ngIf="!license.isRenewal" class="flex flex-col gap-2">
          <ul>
            <li *ngIf="this.showNewIncompleteDates(license.applicationDate)">Incomplete: An application is considered incomplete if the application is missing required information
              (e.g., the application fee has not been paid or the applicant did not submit fingerprints). If the application is incomplete,
              we will notify you by email to give you an opportunity to make your application complete. You have 30 days from the initial date you
              are notified to complete your application. If you fail to do so, the application will be closed.
            </li>
            <li *ngIf="this.showNewIncompleteDates(license.applicationDate)">Insufficient: An application is considered insufficient if the complete application or site inspection does not
              meet requirements outlined in statute or rule. If the application is insufficient, we will notify you by email to give you an opportunity
              to meet requirements. You will have 30 days from the initial date you are notified to meet requirements, or your application will be denied.
            </li>
            <li *ngIf="!this.showNewIncompleteDates(license.applicationDate)">Incomplete: An application is considered incomplete if the application is missing required information
              (e.g., the application fee has not been paid or the applicant did not submit fingerprints). If the application is incomplete,
              we will notify you by email to give you an opportunity to make your application complete. You have 90 days from the initial date you
              are notified to complete your application. If you fail to do so, the application will be closed.
            </li>
            <li *ngIf="!this.showNewIncompleteDates(license.applicationDate)">Insufficient: An application is considered insufficient if the complete application or site inspection does not
              meet requirements outlined in statute or rule. If the application is insufficient, we will notify you by email to give you an opportunity
              to meet requirements. You will have 90 days from the initial date you are notified to meet requirements, or your application will be denied.
            </li>
          </ul>
        </div>

        <div *ngIf="license.isRenewal" class="flex flex-col gap-2">
          <strong>Renewal:</strong>
          <span class="p-l-24">
            <strong>Timely Renewal Applications:</strong>
          </span>
          <span class="p-l-24">
            To be considered a timely renewal under OAR 333-333, renewal applications must be complete, meet all submission requirements, and be submitted at
            least 60 days before the license expiration date. The TLC system will open 120 days before the license expires to allow licensees to apply for the renewal license.
          </span>
          <span class="p-l-24">
            If a timely application is submitted, licensees may continue to operate after the license expires, provided OPS has not yet processed the renewal. Incomplete
            renewal applications will not be considered timely unless all required information is submitted at least 60 days before the expiration date.
          </span>
          <span class="p-l-24">
            <strong>Important:</strong> If your renewal application fee does not clear 30 days after your renewal application is moved to “Renewal approved, pending
            fee payment and clearance” status, your renewal application will be closed. If your license has expired, you will no longer be able to exercise the privileges of the license upon expiration.
          </span>
          <span class="p-l-24">
            You are welcome to re-apply for an OPS license in the future through the TLC system or by mail. To re-apply, you will have to complete the application process, pay the
            application and license fee, and complete a new background check, along with all other requirements of licensure.
          </span>

          <span class="flex-1"></span>

          <span class="p-l-24">
            <strong>Untimely Renewal Applications:</strong>
          </span>
          <span class="p-l-24">
            Under OAR 333-333, any renewal applications submitted fewer than 60 days prior to the license expiration date are considered untimely.
          </span>
          <span class="p-l-24">
            Per ORS 333-333, licensees who submit untimely applications may not continue to operate if OPS is unable to process the untimely renewal before the license expires. In such
            cases, all licensed activities must cease as of the expiration date until the renewal is approved and a new license is issued.
          </span>
          <span class="p-l-24">
            <strong>Important:</strong> If your renewal payment does not clear within 30 days of your renewal application being moved to “Renewal approved, pending fee payment and clearance” status, your renewal application will be closed. If your license has expired, you will no longer be able to exercise the privileges of the license upon expiration.
          </span>
          <span class="p-l-24">
            You are welcome to re-apply for an OPS license in the future through the TLC system or by mail.
          </span>
          <span class="p-l-24">
            When the license expires, TLC-PTS (TLC product tracking system) access and records will be inaccessible. <strong>By 11:45 p.m. on the date of license expiration:</strong>
          </span>
          <ul>
            <li>Operations must pause until the renewal is approved.</li>
            <li>All products will need to have been transferred to another licensee or wasted.</li>
            <li>TLC-PTS must be updated with transfers/wasted products.</li>
            <li>Sales records and other documentation will need to be downloaded by licensees.
                    </li>
          </ul>
          <span class="p-l-24">
            Upon approval of the renewal application, TLC-PTS will begin at zero. Previous TLC-PTS information will not transfer to the renewed license due to the disruption in
            licensure. To re-apply, you will have to complete the application process, pay the application and license fee, and complete a new background check, along with all other requirements of licensure.
          </span>
        </div>

      </div>
      <div style="padding-top: 2em" class="flex flex-col gap-2">
        <span *ngIf="!license.isRenewal">
          <span class="strong">When you click the continue button at the bottom of this page, you will proceed to the psilocybin manufacturer license application. </span>
          <div>The application automatically saves in TLC. You may exit the application and come back later to complete and submit the application, if needed.</div>
        </span>
        <span *ngIf="license.isRenewal">
          <span class="strong">When you click the continue button at the bottom of this page, you will proceed to the psilocybin manufacturer license renewal application.</span>
          <div>The renewal automatically saves in TLC. You may exit the application and come back later to complete and submit the renewal application, if needed.</div>
        </span>
      </div>
      <div style="padding-top: 2em;" class="flex flex-col gap-2">
        <span>
          <strong>DISCLAIMER:</strong>&nbsp;&nbsp;&nbsp;Psilocybin remains a schedule I drug under the federal Controlled Substances Act. Applicants are responsible
          for making their own determinations regarding the legal risks associated with participating in this program. The information you provide
          in your application materials, including applicant name, is subject to disclosure under Oregon's public records laws.
        </span>
      </div>
    </mat-card-content>
  </mat-card>

  <div class="page-break"></div>


  <mat-card>
    <mat-card-title>
      Manufacturer Information Page
    </mat-card-title>
    <mat-card-content>
      <div><strong>Manufacturer Information</strong></div>
      <div class="p-t-16 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span><strong>Operational Name</strong></span>
          <div class="flex flex-row gap-2">
            <span>{{license.entityName}}</span>
          </div>
        </div>
      </div>
      <div class="p-t-16 flex flex-row gap-4" *ngIf="sharedService.isAfterJan15th2027()">
        <div class="flex flex-col gap-2">
          <span><strong>Is this operational name registered as an Assumed Business Name with the Secretary of State in Oregon?</strong></span>
          <div class="flex flex-row gap-2">
            <span>{{license.assumedBusiness ? 'Yes' : 'No'}}</span>
          </div>
        </div>
      </div>
      <div class="p-t-16 flex flex-row gap-4" *ngIf="sharedService.isAfterJan15th2027() && license.assumedBusiness">
        <div class="flex flex-col gap-2">
          <span><strong>Oregon Secretary of State ABN Number</strong></span>
          <div class="flex flex-row gap-2">
            <span>{{license.assumedBusinessNumber}}</span>
          </div>
        </div>
      </div>
      <div class="p-t-16 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span><strong>Manufacturer Website</strong></span>
          <div class="flex flex-row gap-2">
            <span>{{license.entityWebsite}}</span>
          </div>
        </div>
      </div>
      <div><strong>Registered Business</strong></div>
      <div class="p-t-16 flex flex-row gap-4">
        <div class="flex flex-col gap-2 ">
          <span><strong>Is the applicant registered as a business with the Secretary of State (SOS) in Oregon?</strong></span>
          <div class="flex flex-row gap-2">
            <span>{{license.businessInOregon ? 'Yes' : 'No'}}</span>
          </div>
        </div>
      </div>
      <div class="p-t-16 flex flex-row gap-4" *ngIf="license.businessInOregon">
        <div class="flex flex-col gap-2">
          <span><strong>Oregon Secretary of State Registration Number</strong></span>
          <div class="flex flex-row gap-2">
            <span>{{license.secretaryofStateNumber}}</span>
          </div>
        </div>
      </div>
      <div class="p-t-16 flex flex-row gap-4" *ngIf="!license.businessInOregon">
        <div class="flex flex-col gap-2">
          <span><strong>Is the applicant registered as a business in another state, US territory or a freely associated state?</strong></span>
          <div class="flex flex-row gap-2">
            <span>{{license.registeredBusiness ? 'Yes' : 'No'}}</span>
          </div>
        </div>
      </div>
      <div class="p-t-16 flex flex-row gap-4" *ngIf="license.registeredBusiness && !license.businessInOregon">
        <div class="flex flex-col gap-2">
          <span><strong>Please provide the location (state, US territory, or freely associated state) where the Manufacturer is registered as a business and the registration number.</strong></span>
          <div class="flex flex-row gap-2">
            <span>Location Registered: </span>
            <span>{{license.registeredIn}}</span>
          </div>
          <div class="flex flex-row gap-2">
            <span>Registration Number: </span>
            <span>{{license.registryNumber}}</span>
          </div>
        </div>
      </div>
      <div class="p-t-16 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <div class="flex flex-row gap-2">
            <span *ngIf="!license.isRenewal">
              <span class="k-icon"  [ngClass]="license.registrationAttestation ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">I understand licensees that are required to be registered with the Oregon Secretary of State must register prior
              to receiving a license and maintain registration per OAR 333-333-4400 (11).</span>
            </span>
            <span *ngIf="license.isRenewal">
              <span class="k-icon"  [ngClass]="license.registrationAttestation ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">I understand that applicants are required to be registered with the Oregon Secretary of State and must ensure they are still registered prior
              to applying for a renewal and maintain registration per OAR 333-333-4400 (11).</span>
            </span>
          </div>
        </div>
      </div>
      <div class="p-t-16 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span><strong>Other OPS Licenses or Permits</strong></span>
          <div class="flex flex-row gap-2">
            <span>
              <span class="k-icon"  [ngClass]="license.previousLicense ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">Check the box if the applicant applied for or received any other licenses or permits from Oregon Psilocybin Services</span>
            </span>
          </div>
        </div>
      </div>
      <div class="p-t-16 flex flex-row gap-4">
        <div class="flex flex-col gap-2">
          <span><strong>Please provide the license id(s) for each Oregon Psilocybin Services license</strong></span>
          <div class="flex flex-row gap-2">
            <span class="text-wrap">{{license.affiliatedLicenses}}</span>
          </div>
        </div>
      </div>
    </mat-card-content>

      <mat-card-content>
        <h3>Manufacturer Address</h3>
        <h3>Physical Address</h3>
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Street Apt/Unit/Suite</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.physicalStreet}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>City</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.physicalCity}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>State</strong></span>
            <div class="flex flex-row gap-2">
              <span>OR</span>
            </div>
          </div>
        </div>
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Zip</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.physicalZip}}</span>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <span><strong>County</strong></span>
            <div class="flex flex-row gap-2">
              <span>{{license.physicalCounty}}</span>
            </div>
          </div>
        </div>
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <span><strong>Please provide a brief description of the premises</strong></span>
            <div class="flex flex-row gap-2">
              <span class="text-wrap">{{license.premisesDescription}}</span>
            </div>
          </div>
        </div>
        <h3>Mailing Address</h3>
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <div class="flex flex-row gap-2">
              <span class="flex flex-row">
                <span class="k-icon"  [ngClass]="license.mailingIsPhysical ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                <span class="text-wrap">Same as Physical</span>
              </span>
            </div>
          </div>
        </div>
        <div *ngIf="!license.mailingIsPhysical">
          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>Street Apt/Unit/Suite</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{license.mailingStreet}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>City</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{license.mailingCity}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span class="strong">State/US territory/freely associated state</span>
              <div class="flex flex-row gap-2">
                <span>{{license.mailingState}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span class="strong">Zip</span>
              <div class="flex flex-row gap-2">
                <span>{{license.mailingZip}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>County</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{license.mailingCounty}}</span>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="license.isRenewal" class="flex flex-col gap-4">
          <span class="text-wrap"><strong>Is all the information on this screen current and correct?</strong></span>
          <span class="text-wrap strong">Some information may be outdated or incorrect but you cannot change it on this application.
                  These changes require additional documentation and possibly additional fees. These changes are made by a Change Request.
                  If information is incorrect or outdated, please select "No," below and follow the instructions for a Change Request.</span>
          <span>{{license.manufacturerInformationCorrect ? 'Yes' : 'No'}}</span>

          <div class="flex flex-col gap-2" *ngIf="!license.manufacturerInformationCorrect">
            <span class="text-wrap"><strong>Please list the information that is not current and correct</strong></span>

            <div class="flex flex-row gap-2">
              <span class="text-wrap">{{license.manufacturerInformationCorrectReason}}</span>
            </div>
            <div class="text-wrap">You are required to submit a Change Request to update this information. For more information on Change Requests, please see the TLC Home Page, Change Requests section.
              This is the first page you see when you log into TLC.</div>
          </div>
        </div>
      </mat-card-content>
  </mat-card>

  <div class="page-break"></div>

  <mat-card>
    <mat-card-title>
        Applicant Information Page
      </mat-card-title>
      <mat-card-content>
        <div><strong>Manage Applicants</strong></div>
        <span class="strong" *ngIf="!license.isRenewal">An application for a psilocybin manufacturing license must identify all individuals and legal entities who qualify as
          applicants as described in OAR 333-333-1010 and OAR 333-333-4030. Applicants are responsible for ensuring all individuals and
          legal entities who meet the definition of an applicant are identified.</span>
        <span class="strong" *ngIf="license.isRenewal">A renewal application for a psilocybin manufacturing license must identify all individuals and legal entities who qualify
          as applicants as described in OAR 333-333-1010 and OAR 333-333-4030. Applicants are responsible for ensuring all individuals and legal entities who
          meet the definition of an applicant are identified. </span>
        <div style="padding-top: 1em" class="flex flex-col gap-2">
          <span><strong>Applicants are individuals or legal entities who:</strong></span>
          <ul>
            <li>Hold or control an interest of more than 20 percent in the entity proposed to be licensed;
          </li>
          <li>Are entitled to receive 20 percent or more of revenue, profits or proceeds from the entity proposed to be licensed; or
          </li>
          <li>Are entitled to exercise control over the entity proposed to be licensed.
          </li>
          </ul>
        </div>

        <div style="padding-top: 1em" class="flex flex-col gap-2">
          <span><strong>If a legal entity is an applicant, the following individuals within the legal entity are also
            applicants:</strong></span>
          <ul>
            <li>If an applicant is a limited partnership, each general partner in the limited partnership.
            </li>
            <li>If an applicant is a limited liability company, each manager and managing member of the limited liability company.
            </li>
            <li>If the applicant is a for-profit corporation, each principal officer of the corporation.
            </li>
            <li>If the applicant is a non-profit entity, each principal officer of the entity.
            </li>
            <li>Any individual within the legal entity who meets the definition of applicant in OAR 333-333-
              1010.
            </li>
          </ul>
        </div>

        <div style="padding-top: 1em" class="flex flex-col gap-2">
          <span><strong>Guidance for entering applicants on this screen</strong></span>
          <ul>
            <li>All applicants must be entered on this screen
            </li>
            <li>If an individual within a legal entity is identified as an applicant, please add them as an individual applicant
            </li>
          </ul>
        </div>

        <div style="padding-top: 1em" class="flex flex-col gap-2">
          <span><strong>Individual and Legal Entity Applicant Information Forms</strong></span>
          <span class="p-l-24">
            Each individual and legal entity applicant must complete an applicant information form where they will
            provide their applicant information, agree to be added as an applicant to the application, agree to the
            designated point of contact for the application, and complete attestations. Applicants are responsible for
            completing and ensuring all applicant information forms are uploaded on the Applicant Information tab,
            in the Individual Applicants and/or Entity Applicants sections. Individual and legal entity applicant
            information forms can be found on the Oregon Psilocybin Services - Apply for a Manufacturer License Webpage.
          </span>
        </div>
        <div style="padding-top: 1em" class="flex flex-col gap-4">
          <span>
            <span class="k-icon"  Class="k-i-checkbox-checked"></span>
            <span class="text-wrap">I understand Oregon Psilocybin Services will charge a change fee of $250 per applicant for any change
                      to a previously approved license that results in the addition of an applicant. This change fee applies regardless of whether the licensee
                      requests the change at renewal or during the term of their license.</span>
          </span>
          <span>
            <span class="k-icon"  Class="k-i-checkbox-checked'"></span>
            <span class="text-wrap">I understand Oregon Psilocybin Services may deny an application if a person identified as an applicant for
              the entity proposed to be licensed does not meet the definition of applicant in OAR 333-333-1010; or a person who meets the definition of
              applicant in OAR 333-333-1010 has not been disclosed on the application.</span>
          </span>
        </div>
        <div *ngIf="license.isRenewal">
        <div class="flex flex-col gap-4">
          <span class="text-wrap"><strong>Is all the information on this screen current and correct, including the applicants listed?</strong></span>
          <span class="text-wrap strong">Some information may be outdated or incorrect but you cannot change it on this application.
            These changes require additional documentation and possibly additional fees. These changes are made by a Change Request.
            If information is incorrect or outdated, please select "No," below and follow the instructions for a Change Request.</span>
          <span>{{license.applicantsCorrect ? 'Yes' : 'No'}}</span>
          <div class="flex flex-col gap-2" *ngIf="!license.applicantsCorrect">
            <span class="text-wrap"><strong>Please list the information that is not current and correct</strong></span>
            <div class="flex flex-row gap-2">
              <span class="text-wrap">{{license.applicantsCorrectReason}}</span>
            </div>
            <div class="text-wrap">You are required to submit a Change Request to update this information. For more information on Change Requests, please see the TLC Home Page, Change Requests section.
              This is the first page you see when you log into TLC.</div>
          </div>
        </div>
      </div>
      <br>
      <div class="p-t-16 flex flex-row gap-4">
          <span class="text-wrap"><strong>Primary Point of Contact</strong></span>
        </div>
        <div class="p-t-16 flex flex-row gap-4">
          <div class="flex flex-col gap-2">
            <div class="flex flex-col md:flex-row gap-2">
              <div class="flex flex-col w-full md:w-1/2">
                <span><strong>Contact Name</strong></span>
                {{license.primaryContactName}}
              </div>
              <div class="flex flex-col w-full md:w-1/2">
                <span><strong>Contact Phone</strong></span>
                {{license.primaryContactNumber | mask: '(000) 000-0000 000000'}}
              </div>
            </div>

            <div class="flex flex-col md:flex-row gap-2">
              <div class="flex flex-col w-full md:w-1/2">
                <span><strong>Email Address</strong></span>
                <span>{{license.primaryContactEmail}}</span>
              </div>
              <div class="flex flex-col w-full md:w-1/2">
                <span><strong>Preferred Language</strong></span>
                <span>{{license.language}}</span>
              </div>
            </div>
          </div>
        </div>

      <br>
      <div class="flex flex-col w-full">
        <div><strong>Individual Applicants/ Licensees</strong></div>
        <div class="flex flex-row w-full">
          <span class="flex flex-col w-[50%]">First</span>
          <span class="flex flex-col w-[25%]">Last</span>
          <span class="flex flex-col w-[25%]">Status</span>
        </div>
        <div class="flex flex-col w-full">
          <div *ngFor="let applicant of applicants" class="flex flex-row w-full gap-2">
            <span class="flex flex-col w-[50%]">
              <span>{{applicant.legalFirstName}}</span>&nbsp;
              <span>{{applicant.legalMiddleName}}</span>&nbsp;
            </span>
            <span class="flex flex-col w-[25%]">
              <span>{{applicant.legalLastName}}</span>
            </span>
            <span class="flex flex-col w-[25%]">
              <span>Completed</span>
            </span>
          </div>
        </div>
      </div>

      <br>
      <div class="flex flex-col w-full">
        <div><strong>Entity  Applicants</strong></div>
        <div class="flex flex-row w-full">
          <span class="flex flex-col w-[50%]">Entity</span>
          <span class="flex flex-col w-[50%]">Status</span>
        </div>
        <div class="flex flex-col w-full">
          <div *ngFor="let applicant of entityApplicants" class="flex flex-row w-full gap-2">
            <span class="flex flex-col w-[50%]">
              <span>{{applicant.entityName}}</span>
            </span>
            <span class="flex flex-col w-[50%]">
              <span>Completed</span>
            </span>
          </div>
        </div>
      </div>

      <br>

      <!--Applicants-->
      <div class="flex flex-col">
        <div><strong>Applicant Information</strong></div>
        <div *ngFor="let applicant of applicants" class="p-b-16">
          <h3><u>{{applicant.legalFirstName}} {{applicant.legalLastName}}</u></h3>
          <div *ngIf="license.isRenewal" class="flex flex-row">
            <div class="flex flex-col gap-2">
              <span class="text-wrap">Is all the information on this screen current and correct?</span>
              <span class="text-wrap">Some information may be outdated or incorrect but you cannot change it on this application.
                These changes require additional documentation and possibly additional fees. These changes are made by a Change Request.
                If information is incorrect or outdated, please select "No," below and follow the instructions for a Change Request.</span>
              <span>{{applicant.applicantPageCorrect ? 'Yes': 'No'}}</span>
              <div class="flex flex-col gap-2" *ngIf="!applicant.applicantPageCorrect">
                <span class="text-wrap"><strong>Please list the information that is not current and correct</strong></span>
                <div class="flex flex-row gap-2">
                  <span class="text-wrap">{{applicant.applicantPageCorrectReason}}</span>
                </div>
                <div class="text-wrap">You are required to submit a Change Request to update this information. For more information on Change Requests, please see the TLC Home Page, Change Requests section.
                  This is the first page you see when you log into TLC.</div>
              </div>
            </div>
          </div>
          <br>

          <div><strong>Personal Information</strong></div>
          <span><strong>Legal Name</strong></span>
          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>First</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.legalFirstName}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>Last</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.legalLastName}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>Middle</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.legalMiddleName}}</span>
              </div>
            </div>
          </div>

          <span><strong>Preferred Name</strong></span>
          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>First</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.preferredFirstName}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>Last</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.preferredLastName}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>Middle</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.preferredMiddleName}}</span>
              </div>
            </div>
          </div>

          <span><strong>Prior names and aliases</strong></span>
          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>This information is used for the purposes of the background check</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.alternateNames}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>Date of Birth</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.dob | date}}</span>
              </div>
            </div>
          </div>

          <div class="flex flex-col mt-4"><strong>*SOCIAL SECURITY NUMBER DISCLOSURE:</strong></div>
          <ul style="padding-top: 1em; padding-left: 1em"><li>
            As part of your application for an initial license or license renewal, Federal and
            State laws require you to provide your Social Security Number (SSN), if you have one, to Oregon Psilocybin Services for child support enforcement
            purposes (42 USC § 666(a)(13) & ORS 25.785). If you are an applicant or licensee and you have an SSN but fail to provide your SSN, Oregon
            Psilocybin Services may refuse to process your application. Your SSN will be used only for child support enforcement purposes
            unless you confirm your agreement that OPS can use it for administrative purposes as well.</li>
          </ul>

          <div style="padding-top: 1em; padding-left: 1em">
            <span class="strong">IMPORTANT NOTE: If you do not have a social security number, you may still be licensed or permitted by Oregon Psilocybin Services. </span>
          </div>

          <ul style="padding-top: 1em; padding-left: 1em"><li>
            Based on our authority under OAR 333-333-4100, we are requesting your voluntary consent to use your SSN for the following
            administrative purposes only: to positively confirm your identity during the criminal records check. Oregon Psilocybin Services will not
            deny you any rights, benefits or privileges otherwise provided by law if you do not consent to use of your SSN for these administrative
            purposes (5 USC§ 552(a)).
            <span class="strong">Please check the appropriate box next to the social security field indicating whether you consent<br> or do not consent.</span>
          </li></ul>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>SSN</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.ssn}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>SSN</strong></span>
              <div class="flex flex-row gap-2">
                <span class="flex flex-row">
                  <span class="k-icon" [ngClass]="applicant.noSSN ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                  <span class="text-wrap">Applicant doesn't have a social security number</span>
                </span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span class="strong">Do you consent to use of SSN for purposes of confirming identity during a criminal records check?</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.ssnAttestation ? 'Yes' : 'No'}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4" *ngIf="license.isRenewal">
            <div class="flex flex-col gap-2">
              <span class="strong">Since the last time you applied for a license/renewal have you had any updates to your convictions history related to misdemeanors or felonies?</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.changeInConvictionHistory ? 'Yes' : 'No'}}</span>
              </div>
              <span *ngIf="license.isRenewal">Oregon Background Check Unit provides background checks for OPS. We will reach out if additional background check work is required.</span>
            </div>
          </div>

          <span>
            <span class="strong">*For purposes of these questions, “license” means any professional or occupational license, permit or certification that authorizes an individual
                    to engage in an occupation or business, issued by a local, state, or tribal governmental entity, or by a governmental body in another country.</span>
          </span>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span class="strong">In the last 10 years, have you held a license in Oregon or in another state or country?</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.heldLicense ? 'Yes' : 'No'}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span class="strong">In the last 10 years, have you been denied a license? If yes, please upload documentation explaining why and provide all relevant information.</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.deniedLicense ? 'Yes' : 'No'}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span class="strong">For any license you have held, have you been subject to discipline by the entity that issued the license or had the license suspended or revoked in the last 10 years?
                    If so, please upload documentation explaining the reasons for the discipline or revocation and provide all relevant documentation.</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.subjectToDiscipline ? 'Yes' : 'No'}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span class="strong">In the last 10 years, have you been sued for money damages related to work you provided under a license? If yes, please upload documentation to explain and provide all relevant documentation.</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.suedForDamages ? 'Yes' : 'No'}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span class="strong">In the last 10 years, have you settled allegations or claims against you related to a license? If so, please upload documentation to explain and provide all relevant documentation.</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.settledAllegations ? 'Yes' : 'No'}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span class="strong">Has anyone ever alleged that you abused a child or an adult? If you answered yes, please upload documentation to explain the events and provide all relevant documentation.</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.allegedAbuse ? 'Yes' : 'No'}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4" *ngIf="applicant.allegedAbuse">
            <div class="flex flex-col gap-2">
              <span class="strong">Was the allegation substantiated? If you answered yes, please upload documentation to explain the events and provide all relevant documentation.</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.substantiatedAllegation ? 'Yes' : 'No'}}</span>
              </div>
            </div>
          </div>

          <h3>Contact Information</h3>
          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>Primary Phone</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.phone}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>Alternate Phone</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.alternatePhone}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>Email</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.email}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>Confirm Email</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.email}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>Preferred Language</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.language}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>Other OPS Licenses or Permits</strong></span>
              <div class="flex flex-row gap-2">
                <span>
                  <span class="k-icon"  [ngClass]="applicant.previousLicense ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                  <span class="text-wrap">Check the box if the applicant applied for or received any other licenses or permits from Oregon Psilocybin Services</span>
                </span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4" *ngIf="applicant.previousLicense">
            <div class="flex flex-col gap-2">
              <span><strong>Please provide the license id(s) for each Oregon Psilocybin Services license.</strong></span>
              <div class="flex flex-row gap-2">
                <span class="text-wrap">{{applicant.affiliatedLicenses}}</span>
              </div>
            </div>
          </div>

          <h3>Address</h3>
          <h3>Physical Address</h3>
          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>Street Apt/Unit/Suite</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.physicalStreet}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>City</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.physicalCity}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span class="strong">State/US territory/freely associated state</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.physicalState}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span class="strong">Zip</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.physicalZip}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>County</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.physicalCounty}}</span>
              </div>
            </div>
          </div>

          <h3>Mailing Address</h3>
          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <div class="flex flex-row gap-2">
                <span>
                  <span class="k-icon"  [ngClass]="applicant.mailingIsPhysical ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                  <span class="text-wrap">Same as Physical</span>
                </span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>Street Apt/Unit/Suite</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.mailingStreet}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>City</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.mailingCity}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span class="strong">State/US territory/freely associated state</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.mailingState}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span class="strong">Zip</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.mailingZip}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>County</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.mailingCounty}}</span>
              </div>
            </div>
          </div>

          <br>

          <div class="m-t-8 flex flex-row" >
            <div class="flex flex-col gap-3">
              <span><strong>Residential history outside of Oregon in the past 5 years</strong></span>
              <span>*This information is used for the purposes of the background check.</span>
              <span>*City, state, country, from month/year to month/year.</span>
              <div class="flex flex-row" *ngFor="let residence of applicant.residentialHistory">
                <div class="flex flex-row gap-1" >
                  <span>{{residence.city}}</span>
                  <span>{{residence.state}},</span>
                  <span>{{residence.country}}</span>
                  <span class="m-l-8"><strong>From:</strong></span>
                  <span>{{residence.from | date: 'MMM, yyyy'}}</span>
                  <span class="m-l-8"><strong>To:</strong></span>
                  <span>{{residence.to | date: 'MMM, yyyy'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>


    <h3>Identity Verification</h3>
    <div class="p-t-16 flex flex-row gap-4">
      <div class="flex flex-col gap-2">
        <span>Please visit the OPS-Laboratory License webpage to download required forms.</span>
        <div>You must upload a copy of the &nbsp;&nbsp;&nbsp;<span style="font-weight: 700; letter-spacing: 0.5px; font-style: italic;">&nbsp;&nbsp;front and back&nbsp;&nbsp;</span>&nbsp;&nbsp;&nbsp; of a valid, unexpired government-issued photo identification. Accepted identification includes:</div>
        <ul>
        <li>Passport;</li>
        <li>Driver license, whether issued by the State of Oregon or by another state of the United States - &nbsp;&nbsp;&nbsp;&nbsp;<i>front and back</i>&nbsp;&nbsp;&nbsp;;</li>
        <li>Identification card issued under ORS 807.400 - &nbsp;&nbsp;&nbsp;<i>front and back</i>&nbsp;&nbsp;;</li>
        <li>United States military identification card - &nbsp;&nbsp;&nbsp;<i>front and back</i>&nbsp;&nbsp;;</li>
        <li>An identification card issued by a federally recognized Indian tribe with photo, name and date of birth - &nbsp;&nbsp;&nbsp;<i>front and back</i>&nbsp;&nbsp;&nbsp;; or</li>
        <li>Any other identification card issued by a state or territory that bears a picture of the person, the name of the person, the person's date of birth and a physical description of the person - &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i>front and back</i></li>
        </ul>
        <div>A copy of proof of having served in the Armed Forces, such as but not limited to, submitting a Veteran's Administration form DD-214 - &nbsp;&nbsp;&nbsp;<i>front and back</i></div>
      </div>

    </div>

    <br>

    <div>
      <h4>Current Documents</h4>
      <div>
        <div class="flex flex-row w-full">
          <span class="flex flex-col strong w-[40%]">File</span>
          <span class="flex flex-col strong w-[60%]">Requirement</span>
        </div>
        <div *ngFor="let applicant of applicants">
          <div *ngFor="let document of applicant.applicantDocuments" class="flex flex-row">
          <span class="flex flex-col w-[40%]">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
          <span class="flex flex-col w-[60%]">
            <span *ngFor="let type of document.types">
              <span *ngFor="let docType of documentTypes">
                <span *ngIf="docType.id == type"> {{docType.type}} </span>
              </span>
            </span>
          </span>
          <span *ngIf="document.deprecated" style="color:red">Deprecated</span>
          </div>
        </div>

      </div>
    </div>

    <br><br>


      <mat-card-content>
        <div><strong>Entity Applicants</strong></div>
        <div *ngFor="let applicant of entityApplicants" class="p-b-16">
          <h3><u>{{applicant.entityName}}</u></h3>
          <div *ngIf="license.isRenewal" class="flex flex-row">
            <div class="flex flex-col gap-2">
              <span class="text-wrap">Is all the information on this screen current and correct?</span>
              <span class="text-wrap">Some information may be outdated or incorrect but you cannot change it on this application.
                These changes require additional documentation and possibly additional fees. These changes are made by a Change Request.
                If information is incorrect or outdated, please select "No," below and follow the instructions for a Change Request.</span>
              <span>{{applicant.applicantPageCorrect ? 'Yes': 'No'}}</span>
              <div class="flex flex-col gap-2" *ngIf="!applicant.applicantPageCorrect">
                <span class="text-wrap"><strong>Please list the information that is not current and correct</strong></span>

                <div class="flex flex-row gap-2">
                  <span class="text-wrap">{{applicant.applicantPageCorrectReason}}</span>
                </div>
                <div class="text-wrap">You are required to submit a Change Request to update this information. For more information on Change Requests, please see the TLC Home Page, Change Requests section.
                  This is the first page you see when you log into TLC.</div>
              </div>
            </div>
          </div>

          <h3>Contact Information</h3>
          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>Legal entity name</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.entityName}}</span>
              </div>
            </div>
          </div>

          <h3>Registered Business</h3>
          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>Is the applicant registered as a business with the Secretary of State (SOS) in Oregon?</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.businessInOregon ? 'Yes' : 'No'}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4" *ngIf="applicant.businessInOregon">
            <div class="flex flex-col gap-2">
              <span><strong>Oregon Secretary of State Registration Number</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.secretaryofStateNumber}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4" *ngIf="!applicant.businessInOregon">
            <div class="flex flex-col gap-2">
              <span><strong>Is the applicant registered as a business in another state, US territory or a freely associated state?</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.registeredBusiness ? 'Yes' : 'No'}}</span>
              </div>
            </div>
          </div>

          <span *ngIf="applicant.registeredBusiness"><strong>Please provide the location (state, US territory, or freely associated state) where the Service Center is registered as a business and the registration number.</strong></span>
          <div class="p-t-16 flex flex-row gap-4" *ngIf="applicant.registeredBusiness">
            <div class="flex flex-col gap-2">
              <span><strong>Location Registered</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.registeredIn}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4" *ngIf="applicant.registeredBusiness">
            <div class="flex flex-col gap-2">
              <span><strong>Registration Number</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.registryNumber}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <div class="flex flex-row gap-2">
                <span>
                  <span class="k-icon"  [ngClass]="license.registrationAttestation ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                  <span class="text-wrap">I understand licensees that are required to be registered with the Oregon Secretary of State must register prior
                                to receiving a license and maintain registration per OAR 333-333-4400 (11).</span>
                </span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>Other OPS Licenses or Permits</strong></span>
              <div class="flex flex-row gap-2">
                <span>
                  <span class="k-icon"  [ngClass]="license.previousLicense ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                  <span class="text-wrap">Check the box if the applicant applied for or received any other licenses or permits from Oregon Psilocybin Services</span>
                </span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4" *ngIf="applicant.previousLicense">
            <div class="flex flex-col gap-2">
              <span><strong>Please provide the license id(s) for each Oregon Psilocybin Services license.</strong></span>
              <div class="flex flex-row gap-2">
                <span class="text-wrap">{{applicant.affiliatedLicenses}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>Contact Phone</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.primaryContactNumber}}</span>
              </div>
            </div>

            <div class="flex flex-col gap-2">
              <span><strong>Preferred Language</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.language}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>Email Address</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.primaryContactEmail}}</span>
              </div>
            </div>

            <div class="flex flex-col gap-2">
              <span><strong>Confirm Email Address</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.primaryContactEmail}}</span>
              </div>
            </div>
          </div>

          <h3>Addresses</h3>
          <span>Headquarters Address</span>
          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>Street Apt/Unit/Suite</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.headquartersStreet}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>City</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.headquartersCity}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span class="strong">State/US territory/freely associated state</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.headquartersState}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span class="strong">Zip</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.headquartersZip}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>County</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.headquartersCounty}}</span>
              </div>
            </div>
          </div>

          <span>Physical Address</span>
          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <div class="flex flex-row gap-2">
                <span>
                  <span class="k-icon"  [ngClass]="applicant.physicalIsHeadquarters ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                  <span class="text-wrap">Same as Headquarters</span>
                </span>
              </div>
            </div>
          </div>
          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>Street Apt/Unit/Suite</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.physicalStreet}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>City</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.physicalCity}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span class="strong">State/US territory/freely associated state</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.physicalState}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span class="strong">Zip</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.physicalZip}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>County</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.physicalCounty}}</span>
              </div>
            </div>
          </div>

          <span>Mailing Address</span>
          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <div class="flex flex-row gap-2">
                <span>
                  <span class="k-icon"  [ngClass]="applicant.mailingIsHeadquarters ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                  <span class="text-wrap">Same as Headquarters</span>
                </span>
              </div>
            </div>
          </div>
          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <div class="flex flex-row gap-2">
                <span>
                  <span class="k-icon"  [ngClass]="applicant.mailingIsPhysical ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                  <span class="text-wrap">Same as Physical</span>
                </span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span><strong>Street Apt/Unit/Suite</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.mailingStreet}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>City</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.mailingCity}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span class="strong">State/US territory/freely associated state</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.mailingState}}</span>
              </div>
            </div>
          </div>

          <div class="p-t-16 flex flex-row gap-4">
            <div class="flex flex-col gap-2">
              <span class="strong">Zip</span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.mailingZip}}</span>
              </div>
            </div>
            <div class="flex flex-col gap-2">
              <span><strong>County</strong></span>
              <div class="flex flex-row gap-2">
                <span>{{applicant.mailingCounty}}</span>
              </div>
            </div>
          </div>

          <br>
          <div class="flex flex-col w-full">
            <div><strong>Individual Applicants/ Licensees</strong></div>
            <div>Available Applicants</div>
            <div class="flex flex-row w-full">
              <span class="flex flex-col w-[50%]">First</span>
              <span class="flex flex-col w-[50%]">Last</span>
            </div>
            <div class="flex flex-col w-full">
              <div *ngFor="let indApplicant of getAvailableApplicantsForEntity(applicant)" class="flex flex-row w-full gap-2">
                <span class="flex flex-col w-[50%]">
                  <span>{{indApplicant.legalFirstName}}</span>&nbsp;
                  <span>{{indApplicant.legalMiddleName}}</span>&nbsp;
                </span>
                <span class="flex flex-col w-[50%]">
                  <span>{{indApplicant.legalLastName}}</span>
                </span>
              </div>
            </div>
          </div>

          <br>
          <div class="flex flex-col w-full">
            <div>Associated Applicants</div>
            <div class="flex flex-row w-full">
              <span class="flex flex-col w-[50%]">First</span>
              <span class="flex flex-col w-[50%]">Last</span>
            </div>
            <div class="flex flex-col w-full">
              <div *ngFor="let associatedApplicant of applicant.applicants" class="flex flex-row w-full gap-2">
                <span class="flex flex-col w-[50%]">
                  <span>{{associatedApplicant.legalFirstName}}</span>&nbsp;
                  <span>{{associatedApplicant.legalMiddleName}}</span>&nbsp;
                </span>
                <span class="flex flex-col w-[50%]">
                  <span>{{associatedApplicant.legalLastName}}</span>
                </span>
              </div>
            </div>
          </div>

      </div>

      </mat-card-content>

      <br>
      <h4>Supporting Documents</h4>
      <div>You must provide a completed entity applicant information form</div>
      <br>
      <div>
        <h4>Current Documents</h4>
        <div>
          <div class="flex flex-row w-full">
            <span class="flex flex-col strong w-[40%]">File</span>
            <span class="flex flex-col strong w-[60%]">Requirement</span>
          </div>
          <div *ngFor="let applicant of entityApplicants">
            <div *ngFor="let document of applicant.applicantDocuments" class="flex flex-row">
            <span class="flex flex-col w-[40%]">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
            <span class="flex flex-col w-[60%]">
            <span *ngFor="let type of document.types">
                <span *ngFor="let docType of documentTypes">
                  <span *ngIf="docType.id == type"> {{docType.type}} </span>
                </span>
              </span>
            </span>
            <span *ngIf="document.deprecated" style="color:red">Deprecated</span>
            </div>
          </div>

        </div>
      </div>

    <div class="page-break"></div>

    <mat-card-title>
      Financial Interest Page
    </mat-card-title>
      <mat-card-content>
        <div><strong>Financial Interest Disclosures</strong></div>
        <div class="flex flex-col gap-2">
          <div><strong>Restriction on financial interests on multiple licenses (ORS 475A.280)</strong></div>
          <div>An individual may not have a financial interest in:</div>
          <ul>
            <li>More than one psilocybin product manufacturer; or;</li>
            <li>More than five psilocybin service center operators</li>
          </ul>
        </div>
        <div style="padding-top: 1em" class="flex flex-col gap-2">
          <div><strong>Financial Interests (OAR 333-333-4040)</strong></div>
          <div>Applicants and licensees must create and maintain complete lists of all individuals and legal
            entities that hold a financial interest in the manufacturer, including contact information for each
            individual or entity and a description of their financial interest. Applicants and licensees must provide
            the information required by this section to Oregon Psilocybin Services within 15 calendar days of the written
            request for such information.
            </div>
            <div><span class="strong">If a legal entity holds a financial interest, the following individuals within the legal entity also hold a financial interest:</span></div>
            <ul>
              <li>For limited partnerships, each general partner in the limited partnership.</li>
              <li>For limited liability companies, each manager and managing member of the limited liability	company.</li>
              <li>For for-profit corporations, each principal officer of the corporation.</li>
              <li>For non-profit entities, each principal officer of the entity.</li>
            </ul>

            <div class="flex flex-col gap-3">
              <div class="flex flex-row items-start">
                <span class="flex items-start gap-1">
                  <span class="k-icon"  [ngClass]="license.financialAttestation ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                  <span class="text-wrap strong">I have read, understand, and agree to adhere to the financial interest requirements outlined in ORS 475A and OAR, Chapter 333.
                          I understand every individual and legal entity applicant in the proposed manufacturer to be licensed must comply with the requirements of ORS 475A.280, Restriction on
                          financial interests in multiple licenses. I understand Oregon Psilocybin Services shall deny an application for a manufacturer license if an individual or legal entity that holds a
                          financial interest in the entity proposed to be licensed holds a financial interest in five or more service center licenses.</span>
                </span>
              </div>
              <div *ngIf="license.isRenewal" class="flex flex-row">
                <div class="flex flex-col gap-2">
                  <span class="text-wrap">Is all the information on this screen current and correct?</span>
                  <span class="text-wrap">Some information may be outdated or incorrect but you cannot change it on this application.
                    These changes require additional documentation and possibly additional fees. These changes are made by a Change Request.
                    If information is incorrect or outdated, please select "No," below and follow the instructions for a Change Request.</span>
                  <span>{{license.financialInterestCorrect ? 'Yes': 'No'}}</span>
                  <div class="flex flex-col gap-2" *ngIf="!license.financialInterestCorrect">
                    <span class="text-wrap"><strong>Please list the information that is not current and correct</strong></span>

                    <div class="flex flex-row gap-2">
                      <span class="text-wrap">{{license.financialInterestCorrectReason}}</span>
                    </div>
                    <div class="text-wrap">You are required to submit a Change Request to update this information. For more information on Change Requests, please see the TLC Home Page, Change Requests section.
                      This is the first page you see when you log into TLC.</div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </mat-card-content>

        <div class="page-break"></div>

        <mat-card-title>
          Endorsements Page
        </mat-card-title>
        <mat-card-content class="flex flex-col gap-4">
          <div *ngIf="!license.isRenewal">A manufacturer may only produce and sell psilocybin products if the manufacturer has received an endorsement from Oregon Psilocybin Services for that type of product.
                  An applicant for a manufacturer license must request an endorsement upon submission of an initial application but may also request to add or remove an endorsement at any time following licensure.</div>
          <div *ngIf="license.isRenewal">A manufacturer may only produce and sell psilocybin products if the manufacturer has received an endorsement from Oregon Psilocybin Services for that type of product.
                  A licensee may request to add or remove an endorsement at any time by making a Change Request. If changing endorsements requires a site inspection, a Change Request fee will apply.</div>
          <div>An individual manufacturer may hold multiple endorsements.</div>
          <br>
          <div *ngIf="!license.isRenewal"><strong>Endorsement Types</strong></div>
          <div *ngIf="!license.isRenewal">Select the endorsements requested. At least one endorsement type must be requested and multiple or all endorsements may be requested.</div>
          <div *ngIf="license.isRenewal"><strong>Current Endorsements</strong></div>
          <div>
            <span class="k-icon" [ngClass]="license.fungiCultivation ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
            <span class="text-wrap gap-2 p-t-2">Fungi Cultivation</span>
          </div>

          <div>
            <span class="k-icon"  [ngClass]="license.psilocybinExtraction ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
            <span class="text-wrap gap-2 p-t-2">Psilocybin Extraction</span>
          </div>

          <div>
            <span class="k-icon"  [ngClass]="license.ediblePsilocybinProduction ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
            <span class="text-wrap gap-2 p-t-2">Edible Psilocybin Production</span>
          </div>

          <div class="flex flex-row" *ngIf="license.ediblePsilocybinProduction">
            <div class="gap-2  p-t-2">
              <span class="k-icon" [ngClass]="license.edibleAttestation ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">I understand a manufacturer with an edible psilocybin production endorsement may only process in a food establishment
                        licensed by the Oregon Department of Agriculture (ODA) and must comply with the applicable provisions of
                        OAR Chapter 603, Division 21, Division 24, Division 25 and Division 28.</span>
            </div>
          </div>
          <div class="gap-2  p-t-2" *ngIf="license.ediblePsilocybinProduction">
              <span class="k-icon"  [ngClass]="license.edibleAttestation ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">I understand a manufacturer with an edible psilocybin production endorsement may not use a psilocybin product to produce
                      edible psilocybin products unless that psilocybin product was processed or cultivated in a food establishment licensed by the ODA in compliance
                      with the applicable provisions of OAR Chapter 603, Division 21, Division 24, Division 25 and Division 28.</span>
          </div>
          <div class="gap-2  p-t-2" *ngIf="license.ediblePsilocybinProduction">
              <span class="k-icon"  [ngClass]="license.denyEndorsementAttestation ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
              <span class="text-wrap">I understand Oregon Psilocybin Services may deny a manufacturer's request for an endorsement or revoke an existing endorsement
                      if the manufacturer cannot or does not meet the requirements outlined in OAR Chapter 333, Division 333.</span>
          </div>
          <br>
          <div *ngIf="license.isRenewal" class="gap-2 p-t-2 flex flex-row">
            <div class="flex flex-col gap-2">
              <span class="text-wrap">Is all the information on this screen current and correct?</span>
              <span class="text-wrap">Some information may be outdated or incorrect but you cannot change it on this application.
                These changes require additional documentation and possibly additional fees. These changes are made by a Change Request.
                If information is incorrect or outdated, please select "No," below and follow the instructions for a Change Request.</span>
              <span>{{license.endorsementsCorrect ? 'Yes': 'No'}}</span>
              <div class="flex flex-col gap-2" *ngIf="!license.endorsementsCorrect">
                    <span class="text-wrap"><strong>Please list the information that is not current and correct</strong></span>

                    <div class="flex flex-row gap-2">
                      <span class="text-wrap">{{license.endorsementsCorrectReason}}</span>
                    </div>
                    <div class="text-wrap">You are required to submit a Change Request to update this information. For more information on Change Requests, please see the TLC Home Page, Change Requests section.
                      This is the first page you see when you log into TLC.</div>
                  </div>
            </div>
          </div>

        </mat-card-content>

        <div class="page-break"></div>
        <mat-card-title>
          Documents Page
        </mat-card-title>
        <mat-card-content class="flex flex-col gap-4">
          <div *ngIf="!license.isRenewal">The Following Documentation is Required to Apply for a Psilocybin Manufacturer License:</div>
          <div *ngIf="license.isRenewal">Upload the Following Documentation to Apply for a Psilocybin Manufacturer License:</div>
          <div class="p-b-8 flex flex-col gap-2" *ngIf="!license.isRenewal">
            <ul>
              <li *ngIf="sharedService.isAfterJan1st()">Property Owner Consent for Manufacturing Psilocybin (updated version) if applicable</li>
              <li>Approved Land Use Compatibility Statement (LUCS)</li>
              <li>Premises plan including boundaries, and camera plan</li>
              <li>Property owner statement (if applicable)</li>
              <li>Social Equity Plan</li>
              <li>Reduced Fee Documentation</li>
              <li>Proposed Premises Pictures</li>
            </ul>
          </div>
          <div class="p-b-8 flex flex-col gap-2" *ngIf="license.isRenewal">
            <ul>
              <li>Social Equity Plan Evaluation</li>
              <li *ngIf="sharedService.isAfterJan1st()">Property Owner Consent for Manufacturing Psilocybin (updated version) if applicable</li>
              <li>Updated Social Equity Plan (not required)</li>
              <li>Approved Land Use Compatibility Statement (LUCS) (not required)</li>
              <li>Premises plan including boundaries, and camera plan (not required)</li>
              <li>Reduced Fee Documentation (not required)</li>
              <li>Updated premises pictures (not required at this time but will be required before renewal site inspection)</li>
            </ul>
          </div>

          <div style="padding-bottom: 1em" *ngIf="!license.isRenewal" class="flex flex-col gap-2">
             <div><strong>Proposed Premises Pictures</strong></div>
             <div class="flex flex-col gap-2">
               <div>Manufacturers must upload pictures of their proposed premises as part of their application. Pictures submitted must clearly show the following:</div>
               <ul>
                  <li>All ingress and egress of a proposed licensed premises</li>
                  <li>Psilocybin secure storage area</li>
                  <li>Psilocybin secure waste storage</li>
                  <li>All limited access areas</li>
                  <li>Client administration area</li>
                  <li>Outdoor areas included on proposed premises</li>
                  <li>Secured storage of video surveillance equipment (not fixed cameras)</li>
                  <li>All four internal corners of the proposed premises</li>
                  <li>All four external corners of the proposed premises</li>
               </ul>
               <div>Please include additional pictures of any areas that are potentially hazardous, unsafe, or may not meet rules requirements.
                 Submitting a complete catalog of pictures will ensure we are able to review your proposed premises in a timely manner and work with you to make any potentially necessary changes.</div>
               <div style="padding-left: 1em"><strong>* </strong>Pictures may be submitted after initial submission of application but are required prior to scheduling a site inspection</div>
               <div style="padding-left: 1em"><strong>** </strong>Do not include any people in your pictures</div>
             </div>
           </div>

           <div style="padding-bottom: 1em" class="flex flex-col gap-2">
             <span><strong>Reduced Fee Request</strong></span>
             <div class="flex flex-col gap-2">
               <div>If requesting a reduced licensing fee, please provide the required supporting documentation:</div>
               <ul>
                  <li>If the proposed licensed manufacturer is a non-profit entity:</li>
                  <li style="padding-left: 2em">Your application must include the Oregon Secretary of State's Registry Number on the Manufacturer Information tab of this application and the non-profit status will be verified by Oregon Psilocybin Services.</li>
               </ul>

               <div>If the proposed licensed manufacturer is an individual applicant, please upload one of the following supporting documents:</div>
               <ul>
                  <li>A copy of a current monthly Supplemental Security Income benefit statement showing dates of coverage</li>
                  <li>A copy of the applicant's current eligibility statement or card if enrolled in Oregon Health Plan</li>
                  <li>A copy of current proof of food stamp benefits from the Oregon Supplemental Nutrition Assistance Program</li>
               </ul>

             </div>
           </div>
           <br>

           <div>
            <h4>Upload Supporting Documents</h4>
             <div class="flex flex-col gap-2">
                  <div>For each document select the requirements it verifies</div>
                  <div class="p-t-8 flex flex-col gap-2">

                  <div>
                    <span class="k-icon" [ngClass]="'k-i-checkbox'"></span>
                    <span class="text-wrap">Approved Land Use Compatibility Statement (LUCS)</span>
                  </div>
                  <div *ngIf="!license.isRenewal">
                    <span class="k-icon" [ngClass]="'k-i-checkbox'"></span>
                    <span class="text-wrap">Premises plan including boundaries, and camera plan</span>
                  </div>
                  <div *ngIf="!license.isRenewal">
                    <span class="k-icon" [ngClass]="'k-i-checkbox'"></span>
                    <span class="text-wrap">Proposed Premises Pictures</span>
                  </div>
                  <div *ngIf="!license.isRenewal">
                    <span class="k-icon" [ngClass]="'k-i-checkbox'"></span>
                    <span class="text-wrap">Social Equity Plan</span>
                  </div>
                  <div>
                    <span class="k-icon" [ngClass]="'k-i-checkbox'"></span>
                    <span class="text-wrap">Reduced Fee</span>
                  </div>
                  <div *ngIf="license.isRenewal">
                    <span class="k-icon" [ngClass]="'k-i-checkbox'"></span>
                    <span class="text-wrap">Updated Social Equity Plan</span>
                  </div>
                  <div *ngIf="license.isRenewal">
                    <span class="k-icon" [ngClass]="'k-i-checkbox'"></span>
                    <span class="text-wrap">Social Equity Plan Evaluation</span>
                  </div>
                  <div *ngIf="license.isRenewal">
                    <span class="k-icon" [ngClass]="'k-i-checkbox'"></span>
                    <span class="text-wrap">Updated premises pictures</span>
                  </div>
                </div>
              </div>
           </div>
           <br>
           <span><strong>Current Documents</strong></span>
             <div class="flex flex-row w-full">
                <span class="flex flex-col strong w-[40%]">File</span>
                <span class="flex flex-col strong w-[60%]">Requirement</span>
              </div>
           <div *ngFor="let document of license.licenseDocuments" class="flex flex-col md:flex-row justify-start">
            <div *ngIf="!document.types.includes(fungiCultivationType) && !document.types.includes(fungiCultivationType) && !document.types.includes(psilocybinExtractionType) && !document.types.includes(ediblePsilocybinProductionType)" class="flex flex-row w-full gap-2">
             <span class="flex flex-col w-[40%]">{{document.name}}</span>
             <span class="flex flex-col w-[60%]">
              <span *ngFor="let type of document.types">
                <span *ngFor="let docType of documentTypes">
                  <span *ngIf="docType.id == type"> {{docType.type}} </span>
                </span>
              </span>
            </span>
            </div>
           </div>
        </mat-card-content>

        <div class="page-break"></div>

        <mat-card-title>
          Fee Information Page
        </mat-card-title>
        <mat-card-content class="flex flex-col gap-4">
          <div class="flex flex-row gap-2">
            <span class="strong" *ngIf="!license.isRenewal">Non-Refundable Manufacturer Application Fee : $500.00</span>
            <span class="strong" *ngIf="license.isRenewal">Non-Refundable Manufacturer Annual License Fee: $10,000 or $5,000 if Applicant Qualifies for Reduced Fee</span>
          </div>
          <div class="flex flex-col gap-4">

          <span style="white-space: pre-wrap" *ngIf="!license.isRenewal">
            The manufacturer application will not be reviewed until payment has been received and cleared. After the application has been submitted, a “Pay Fee” button will be displayed. By clicking this button, payment information below will be displayed along with a remittance form that can be downloaded and submitted with your payment if you prefer to pay in-person. A copy of this information will also be emailed to you after the application is submitted.
          </span>
          <span style="white-space: pre-wrap" *ngIf="license.isRenewal">
           If your license application is approved, pending license fee payment and clearance, you will receive a request to pay the annual licensing fee.
             To request a reduced fee, please upload the required supporting document in
            the “Documents” tab of this application. If you qualify for a reduced license fee, the fee will be reduced accordingly. Please use the same payment instructions to pay the annual license fee.
            <br><br>Please Note: If payment is not submitted within 30 days from the date that you received notice that your renewal application
              has been moved to “renewal approved pending payment and clearance” status, your renewal application will be closed due to non-payment.
              The license will not be renewed until the payment has cleared and processing of the renewal has been completed.

              <br><br>After the application has been submitted and the review of the application has been completed and approved, a “Pay Fee”
              button will be displayed. By clicking this button, payment information below will be displayed along with a remittance form that
              can be downloaded and submitted with your payment if you prefer to pay in-person. A copy of this information will also be emailed
              to you after the application is submitted.
          </span>

          <span>Payment method options:</span>
          <ul>
            <li>Online</li>
            <li>Money Order</li>
            <li>Cashier's Check</li>
            <li>Personal/Business Check (personal and business checks are held for 21 days for clearance)</li>
            <li>Cash* <strong>Please Do Not Mail Cash</strong></li>
          </ul>

          <div *ngIf="!license.isRenewal" class="flex flex-row items-start">
            <span><span class="strong">Instructions for Submitting the Fee Payment by Mail or In-Person</span></span>
          </div>

          <div *ngIf="license.isRenewal" class="flex flex-row items-start">
            <span><span class="strong">Instructions for Submitting the Fee Payment by Mail or In-Person</span></span>
          </div>

          <span *ngIf="!license.isRenewal">
            Money orders and checks are payable to: &nbsp;&nbsp;&nbsp;&nbsp; <span class="strong">Oregon Psilocybin Services</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Money orders and cashier's checks take less time to clear than personal and business checks.
            Personal and business checks are held for 21 days for clearance. Applications will be reviewed
            once payment has been cleared. Application fees are non-refundable.
          </span>

          <span *ngIf="license.isRenewal">
            Money orders and checks are payable to: &nbsp;&nbsp;&nbsp;&nbsp; <span class="strong">Oregon Psilocybin Services</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            Money orders and cashier's checks take less time to clear than personal and business checks.
            Personal and business checks are held for 21 days for clearance. Renewal license fees are non-refundable.
          </span>

          <div class="flex flex-col">
            <span>
              <strong *ngIf="!license.isRenewal">Mailing the application packet, money order or check, and remittance form:</strong>
              <strong *ngIf="license.isRenewal">Mailing the renewal application packet, money order or check, and remittance form:</strong>
            </span>
            <span>Oregon Health Authority - Public Health Division - Fiscal Services</span>
            <span>RE: OPS</span>
            <span>PO Box 14260</span>
            <span>Portland, OR 97293-0260</span>
          </div>

          <div class="flex flex-col">
            <span><span class="strong">In-person payment with a money order or check:</span></span>
            <span>
              To make an in-person fee payment with a money order or check, print the remittance form and proceed to
              Cashier's Office on the second floor of the Portland State Office Building at 800 NE Oregon St, Suite 200,
              Portland, OR 97232 - Hours: 9am to 4pm, Mon to Fri
            </span>
          </div>

          <span>
            Additional instructions: The Cashier's Office window is located on the second floor next to the Vital Health Statistics window.
            If security asks if you have an appointment, you may let them know you are dropping off a payment for Oregon Psilocybin Services
            at the Cashier's Office window which does not require an appointment. Please include the remittance form with the payment.
          </span>

          <div class="flex flex-col">
            <span><span class="strong">To make cash payment arrangements or for payment questions, please contact:</span></span>
            <div style="word-break: break-all; white-space: normal;" class="flex flex-row gap-2 justify-start items-center">

                <div class="flex flex-col sm:flex-row gap-2 justify-start items-center">
                  <span>
                    licensing.psilocybin&#64;oha.oregon.gov </span>
                  <mat-icon>email</mat-icon>
                </div>

              <span>or Licensing Inquiries: 1-971-673-0304</span>
            </div>
          </div>

          <div *ngIf="!license.isRenewal" class="flex flex-col gap-4">
            <h3>Non-Refundable Manufacturer Annual License Fee: $10,000 or $5,000 if Applicant Qualifies for Reduced Fee
            </h3>
            <span>
              If your license application is approved, pending license fee payment and clearance, you will receive a request to pay the annual licensing fee.
              To request a reduced fee, please upload the required supporting document in
              the “Documents” tab of this application. If you qualify for a reduced license fee, the fee will be reduced accordingly. Please use the same payment instructions to pay the annual license fee.
              <span class="strong">
                A license will not be issued until the annual license fee payment is paid and cleared. A licensee may not operate until the effective date of licensure.
              </span>
            </span>
          </div>
        </div>
        </mat-card-content>

        <div class="page-break"></div>
        <mat-card-title>
          Review and Submit Page
        </mat-card-title>

        <mat-card-content class="flex flex-col gap-4">
          <div class="flex flex-col">
            <div class="flex flex-col md:flex-row gap-2">
              <div class="w-full md:w-1/2">
                <div>
                  <span>Manufacturer Information</span>
                </div>
                <div>
                  <div class="flex flex-col gap-2">
                    <div class="flex flex-col 2xl:flex-row">
                      <span class="w-full lg:w-[30%]">
                        <span class="strong">Operational Name</span>
                      </span>
                      <span class="w-full lg:w-[70%] break-words">
                        {{license.entityName}}
                      </span>
                    </div>
                    <div class="flex flex-col 2xl:flex-row">
                      <span class="w-full lg:w-[30%]">
                        <span class="strong">Website</span>
                      </span>
                      <span class="w-full lg:w-[70%] break-all">
                        {{license.entityWebsite}}
                      </span>
                    </div>

                    <div class="flex flex-col 2xl:flex-row">
                      <span class="w-full lg:w-[30%]">
                        <span class="strong">Primary Contact</span>
                      </span>
                      <span class="w-full lg:w-[70%] break-words">
                        {{license.primaryContactName}}
                      </span>
                    </div>
                    <div class="flex flex-col 2xl:flex-row">
                      <span class="w-full lg:w-[30%]">
                        <span class="strong">Contact Phone</span>
                      </span>
                      <span class="w-full lg:w-[70%] break-words">
                        {{license.primaryContactNumber | mask: '(000) 000-0000 000000'}}
                      </span>
                    </div>
                    <div class="flex flex-col 2xl:flex-row">
                      <span class="w-full lg:w-[30%]">
                        <span class="strong">Contact Email</span>
                      </span>
                      <span class="w-full lg:w-[70%] break-all">
                        {{license.primaryContactEmail}}
                      </span>
                    </div>
                    <div class="flex flex-col 2xl:flex-row">
                      <span class="w-full lg:w-[30%]">
                        <span class="strong">Preferred Language</span>
                      </span>
                      <span class="w-full lg:w-[70%] break-words">
                        {{license.language}}
                      </span>
                    </div>
                      <div class="flex flex-col 2xl:flex-row">
                        <span class="w-full lg:w-[30%]"><span class="strong">Physical Address</span></span>
                        <span class="w-full lg:w-[70%] break-words">
                          {{license.physicalStreet}}&nbsp;
                          {{license.physicalCity}}&nbsp;
                          {{license.physicalState}}&nbsp;
                          {{license.physicalZip}}&nbsp;
                          {{license.physicalCounty}}
                        </span>
                      </div>
                      <span>{{license.premisesDescription}}</span>
                      <div class="flex flex-col 2xl:flex-row">
                        <span class="w-full lg:w-[30%]"><span class="strong">Mailing Address</span></span>
                        <span *ngIf="!license.mailingIsPhysical" class="w-full lg:w-[70%] break-words">
                          {{license.mailingStreet}}&nbsp;
                          {{license.mailingCity}}&nbsp;
                          {{license.mailingState}}&nbsp;
                          {{license.mailingZip}}&nbsp;
                          {{license.mailingCounty}}
                        </span>
                        <span *ngIf="license.mailingIsPhysical"  class="w-full lg:w-[70%]">Same as physical</span>
                      </div>

                  </div>
                </div>
              </div>

            </div>
          </div>

          <br><br>

          <div class="flex flex-row w-full gap-4">
              <span><span class="strong">Endorsements Requested</span></span>
              <div class="flex flex-col">
                <div>
                  <span class="k-icon" [ngClass]="license.fungiCultivation ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                  <span class="text-wrap gap-2 p-t-2">Fungi Cultivation</span>
                </div>
                <div>
                  <span class="k-icon" [ngClass]="license.psilocybinExtraction ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                  <span class="text-wrap gap-2 p-t-2">Psilocybin Extraction</span>
                </div>
                <div>
                  <span class="k-icon" [ngClass]="license.ediblePsilocybinProduction ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                  <span class="text-wrap gap-2 p-t-2">Edible Psilocybin Production</span>
                </div>

                <div>
                  <span class="k-icon" [ngClass]="license.businessInOregon ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                  <span>Manufacturer is registered as a business with the Secretary of State (SOS) in Oregon</span>
                  <div *ngIf="license.businessInOregon">Oregon Secretary of State Registry Number:&nbsp;&nbsp;<span>{{license.secretaryofStateNumber}}</span></div>
                </div>
                <div *ngIf="!license.businessInOregon">
                  <span class="k-icon" [ngClass]="license.registeredBusiness ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                  <span>Manufacturer is registered as a business in another state, US territory or a freely associated state</span>
                  <div *ngIf="license.registeredBusiness">Location Registered:&nbsp;&nbsp;<span>{{license.registeredIn}}</span></div>
                  <div *ngIf="license.registeredBusiness">Registration Number:&nbsp;&nbsp;<span>{{license.registryNumber}}</span></div>
                </div>
                <div>
                  <span class="k-icon" [ngClass]="license.previousLicense ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                  <span>Manufacturer has applied for or received any other Oregon Psilocybin licenses</span>
                  <div>Other Licenses:&nbsp;&nbsp;<span>{{license.affiliatedLicenses}}</span></div>
                </div>
              </div>
          </div>

          <br>

          <div class="flex flex-col w-full md:w-1/2">
            <div>
              <div>
                <div class="flex flex-col">
                  <span>Current Documents</span>
                </div>
              </div>
              <div>
                  <div class="flex flex-row">
                  <span class="flex flex-col strong w-[60%]">File</span>
                  <span class="flex flex-col strong">Requirement</span>
                </div>
                <div class="flex flex-col gap-2">
                  <div *ngFor="let document of license.licenseDocuments" class="flex flex-row justify-start items-center">
                    <span class="text-indigo-A700 w-[60%]">{{document.name.length > 15 ? document.name.substring(0,15) + "..." : document.name}}</span>
                    <span class="flex flex-col">
                      <span *ngFor="let type of document.types">
                        <span *ngFor="let docType of documentTypes">
                          <span *ngIf="docType.id == type"> {{docType.type}} </span>
                        </span>
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <br><br>

            <div class="flex flex-col lg:flex-row gap-2">
              <div class="w-full lg:w-1/2">
                <div>
                  <span>Individual Applicants</span>
                </div>
                <div class="flex flex-col">
                  <div *ngFor="let applicant of applicants" class="flex flex-row gap-2">
                    <span>{{applicant.legalFirstName}}</span>&nbsp;
                    <span>{{applicant.legalMiddleName}}</span>&nbsp;
                    <span>{{applicant.legalLastName}}</span>
                  </div>
                </div>
              </div>

              <div class="w-full lg:w-1/2">
                <div>
                  <span>Entity Applicants</span>
                </div>
                <div>
                  <div class="flex flex-col">
                    <div *ngFor="let applicant of entityApplicants" class="flex flex-row gap-2">
                      <span>{{applicant.entityName}}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          <br><br>

          <div><strong>Sign and Submit</strong></div>
          <div class="flex flex-col gap-2">
            <ul>
              <li>I certify the information provided in this application is true and complete to the best of my knowledge. I understand
              falsifying an application, supplying misleading information, or withholding information is grounds for denial of my application or
              revocation of my license.</li>

              <li>I understand I am responsible for making my own determination regarding the legal risks associated with a Schedule
              1 substance under the Federal Controlled Substances Act.</li>

              <li>I understand manufacturer licenses are only valid for the licensed premises and are only issued to the individuals or
              entities listed on the application or subsequently approved by the Authority.</li>

              <li>I understand the information provided in application materials, including applicant name, is subject to disclosure
              under Oregon's public records laws and that certain information may be posted on OHA's website for purposes of license verification.</li>


              <li>I understand all individual applicants must complete and pass a background check as a condition of licensure.</li>


              <li>I understand individual applicants are required to obtain a psilocybin worker permit if they participate in activities
              outlined in OAR 333-333-4070 (1) (a), (b), (c), (d).</li>


              <li>I understand and will adhere to the requirements for Notification of Changes as outlined in OAR 333-333-4200.</li>


              <li>I understand Oregon Psilocybin Services will charge a change fee of $250 per inspection for any change to a previously
              approved license that requires an inspection of the licensed premises. This change fee applies regardless of whether the licensee requests
              the change at renewal or during the term of their license.</li>


              <li>I have read, understand, and agree to adhere to the Oregon Psilocybin Services Revised Statutes (ORS) Chapter 475A, Oregon
              Administrative Rules (OAR) Chapter 333, as well as any other applicable statutes or laws.</li>


              <li>I understand that failure to adhere to these statutes and rules may result in disciplinary action taken against my
              application and any future licenses issued by Oregon Psilocybin Services.</li>


              <li>I certify the proposed licensed premise meets the location requirements outlined in OAR 333-333-4300.</li>


              <li>I understand the psilocybin manufacturer license has a term of one year from the effective date of licensure. If I wish
              to renew my license after that term, I must complete a renewal application.</li>


              <li>I understand a license will not be issued until the license fee payment is paid and cleared. A licensee may not operate
              until the effective date of licensure.</li>


              <li>Applicant(s) understand and will comply with the requirement to complete and submit the Required 303 Applicant and Licensee REAL & SOGI
              Data form in accordance with ORS 475A.374.</li>


              <li>I understand the manufacturer application and annual license fees are non-refundable.</li>
              <li *ngIf="license.isRenewal && sharedService.isAfterJan15th2027()">
                Every product tracking system user for the licensed premises has completed training required by the Authority for the product tracking system.
              </li>
              <li *ngIf="!license.isRenewal && sharedService.isAfterJan15th2027()">
                Every product tracking system user for the licensed premises will complete training required by the Authority for the product tracking system.
              </li>
            </ul>
            <span>
                <span class="k-icon"  [ngClass]="license.attestation ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                <span class="text-wrap">I have read and I understand the above statements</span>
            </span>

            <div class="flex flex-col gap-4">
              <div class="flex flex-row">
                <span>
                  <span class="k-icon"  [ngClass]="license.directoryConsent ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                  <span class="text-wrap">I consent to having my license name, license type, and the contact information selected below listed in the voluntary OPS Licensee Directory.</span>
                </span>
              </div>

              <div style="padding-left: 1em" *ngIf="license.directoryConsent" class="flex flex-col">
                <div class="gap-[5px]">
                  <span>
                    <span class="k-icon"  [ngClass]="license.directoryConsentWebsite ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                    <span class="text-wrap">Website: {{license.directoryWebsite}}</span>
                  </span>
                </div>

                <div class="gap-[5px]">
                  <span>
                    <span class="k-icon"  [ngClass]="license.directoryConsentEmail ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                    <span class="text-wrap">Email: {{license.directoryEmail}}</span>
                  </span>
                </div>

                <div class="gap-[5px]">
                  <span>
                    <span class="k-icon"  [ngClass]="license.directoryConsentPhone ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                    <span class="text-wrap">Phone Number: {{license.directoryPhone}}</span>
                  </span>
                </div>
              </div>

              <div class="flex flex-row">
                <span>
                    <span class="k-icon"  [ngClass]="!license.directoryConsent ? 'k-i-checkbox-checked' : 'k-i-checkbox'"></span>
                    <span class="text-wrap">I <strong>do not </strong> consent to having my license name, license type, and contact information listed in the voluntary OPS Licensee Directory.</span>
                  </span>
              </div>
            </div>
            <span class="text-wrap"><em>Please note, if you do not consent, you may still be licensed with Oregon Psilocybin Services.</em></span>

            <div class="flex flex-col lg:flex-row gap-2 justify-start items-center">
              <span>Signature: {{license.electronicSignature}}</span>
            </div>
          </div>
      </mat-card-content>
  </mat-card>
</div>
